:host {
   display: block;
}

.product-filter {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    
    @include breakpointMin('lg') {
        grid-template-columns: minmax(0, 1fr);
    }

    ::slotted(#categories) {
        grid-column: 1 / span 2;

        @include breakpointMin('lg') {
            grid-column: 1;
        }
    }

}
